const breadcrumbKey = Symbol("breadcrumbKey");

export { breadcrumbKey };
//# sourceMappingURL=breadcrumb.mjs.map
